
import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get } from "lodash";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import "./subAdmin.css";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { bottom } from "@popperjs/core";
import dummyProfile from "../../assets/images/lady.png";
import { TiInfoLarge } from "react-icons/ti";

import Input from "../../components/Input";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import TextArea from "../../components/TextArea";
import ReactReadMoreReadLess from "react-read-more-read-less";
import Verified from "../../assets/images/verification.png";

import {
  extractDate,
  extractOnlyDate,
  extractOnlyMonthYear,
  getFileSize,
  maskToken,
  maskSocialSecurityNumber,
  uploadImage,
  subadminAccessChange,
} from "../../utils/functions";

// Mui & material UI
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import Checkbox from '@mui/material/Checkbox';
import SearchBar from "material-ui-search-bar";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import PaginationItem from '@mui/material/PaginationItem';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { TextField, Popover, Box } from "@mui/material";

// icons
import { FaUser } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { RiFolderUserFill } from "react-icons/ri";
import { RiFileUserLine } from "react-icons/ri";
import { IoIosLink } from "react-icons/io";
import { IoCallOutline } from "react-icons/io5";
import { IoLocationOutline } from "react-icons/io5";
import { AiOutlineMail } from "react-icons/ai";
import { LuContact } from "react-icons/lu";
import { GoCalendar } from "react-icons/go";
import { SlPencil } from "react-icons/sl";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { PiAndroidLogoFill } from "react-icons/pi";
import { MdOutlineFileDownload } from "react-icons/md";

import unblock from "../../assets/images/unblock.png";
import block from "../../assets/images/block.png";
import medal from "../../assets/images/medal.png";

import { SlClose } from "react-icons/sl";
import { RxCross2 } from "react-icons/rx";
import { FaArrowLeft } from "react-icons/fa";
import { IoIosLogOut } from "react-icons/io";
import { TiInfoOutline, TiTick } from "react-icons/ti";
import { BiSolidPackage } from "react-icons/bi";
import { RxCrossCircled } from "react-icons/rx";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { GrApple, GrAndroid } from "react-icons/gr";
import { BsDot, BsEyeFill, BsPlus, BsThreeDotsVertical } from "react-icons/bs";
import { PiHandsClappingBold, PiUserList, PiXCircleFill } from "react-icons/pi";

import JPG from "../../assets/images/jpg.png";
import placeholder from "../../assets/images/placeholder.jpg";
import Pdf from "../../assets/images/Pdf.png";
import certificate from "../../assets/images/ApproveCertificate.png";

import {
  MdBlock,
  MdClose,
  MdEmail,
  MdLocalPhone,
  MdPhone,
} from "react-icons/md";

import {
  IoArchive,
  IoArrowBackCircleOutline,
  IoArrowForwardCircleOutline,
} from "react-icons/io5";
import {
  FaFilter,
  FaGlobe,
  FaPhone,

  FaUserAlt,
  FaMoneyBill,
  FaCheckCircle,
} from "react-icons/fa";

// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  ProfileDetailForm,
  ServiceDetailForm,
  DashHeading,
  Button,
  Filter,
  DpBox,
  Fields,
  Resetbtn,
  Applybtn,
} from "./SubAdminElements";
import FileSizeDisplay from "../../components/FileSize";
import { RiOverline } from "react-icons/ri";

const useStyles = makeStyles((theme) => ({
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 10px', // adds vertical spacing between rows
  },
  paperTableHeight: {
    width: "97%",
    marginLeft: "1rem",
    minHeight: "40vh",
    border: "1px solid rgba(12, 45, 6, 0.10)",
    borderRadius: "10px",
    overflow: "scroll",
  },
  tableMainContainer: {
    maxHeight: "50vh",
    overflowX: "auto",
    overflowY: "auto",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
  tableHeadingRow: {
    position: "sticky", // Make header sticky
    top: 0, // Stick to the top
    zIndex: 1, // Ensure it appears above other rows
    background: "#FFFFFF", // Header background color
    border: "1px solid rgba(17, 153, 38, 0.20)",

  },
  tableBodyRow: {
    background: "#FFFFFF",
    border: "1px solid rgba(17, 153, 38, 0.20)",

    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableHeadingCell: {
    // padding: "0.5rem 1rem !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#1C2D28",
    fontWeight: "500",
    // border: "1px solid #D9E3D9",
    whiteSpace: "nowrap",
    background: "#FFFFFF",
    border: "none"
  },
  textMiddle: {
    // padding: "0.4rem 1rem !important",
    verticalAlign: "middle !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#484848",
    fontFamily: "Roboto",
    fontWeight: "400",
    background: "#FFFFFF",
    border: "none"
  },
  tablePaginationStyle: {
    borderTop: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
  paginationContainer: {
    marginTop: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));





const SubAdminHistory = ({ setUsers, userData }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

  const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "User Management"
  )?.permissions || {};

  const canDelete = !!userManagementPermissions.delete;

  const param = useParams();
  const location = useLocation();
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [userCount, setUserCount] = useState();

  const [skillsDetails, setSkillsDetails] = useState();
  const [userCertificate, setUserCertificate] = useState([])
  const [invitationData, setInvitationData] = useState([])
  const [userInfo, setUserInfo] = useState([])
  const [userInfoData, setUserInfoData] = useState([])
  const [statusData, setStatusData] = useState(false)
  const [statusHistryData, setStatusHistryData] = useState([])
  const [hiredDetailsData, setHiredDetailsData] = useState([])


  const [rejectionReason, setRejectionReason] = useState("");
  const [certificateId, setCertificateId] = useState(null);

  const [blockModal, setBlockModal] = useState(false);
  const [unBlockModal, setUnBlockModal] = useState(false);
  const [description, setDescription] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);



  const [deleteModal, setDeleteModal] = useState(false);
  const [approvedCertificate, setApprovedCertificate] = useState(false);
  const [rejectCertificate, setRejectCertificate] = useState(false);
  const [reasonDeleteModal, setReasonDeleteModal] = useState(false);
  const [actionType, setActionType] = useState(""); // "accept" or "reject"
  const [showRejectionReason, setShowRejectionReason] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [viewActivityData, setViewActivityData] = useState()
  const [profileChecked, setProfileChecked] = useState(false);
  const [documentChecked, setDocumentChecked] = useState(false);
  const [profileReason, setProfileReason] = useState("");
  const [documentReason, setDocumentReason] = useState("");
  const [filterStatus, setFilterStatus] = useState("0")
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [userHistory, setUserHistory] = useState();

  const [anchorEl, setAnchorEl] = useState(null);


  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget); // Open the filter popover
  };

  const handleClose = () => {
    setAnchorEl(null); // Only close the popover without resetting
  };

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;



  // For Pagination
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalDocs, setTotalDocs] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1); // Reset to the first page when rows per page change
  };

  const handleChangePage = (event, newPage) => {
    // handleCancel();
    setPage(newPage); // Update page and trigger data fetch
  };

  const [verificationDocumentModal, setVerificationDocumentModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(""); // Store clicked image source

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
    setVerificationDocumentModal(true);
  };




  // For Select checkbox
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (tableData.length === 0) {
      setSelectedRows([]);
    }
  }, [tableData]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows(tableData.map((item) => item._id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    const newSelectedRows = selectedRows.includes(id)
      ? selectedRows.filter((rowId) => rowId !== id)
      : [...selectedRows, id];
    setSelectedRows(newSelectedRows);
  };

  const handleClearSelection = () => {
    setSelectedRows([]);
  };


  //  this is for open history
  const handleClick = () => {
    setShowTable(!showTable);
  };





  // Get user Gig detail data
  useEffect(() => {
    getViewActivity();

  }, [filterStatus]);

  const getViewActivity = async () => {
    setIsLoading(true);

    try {
      const { data } = await axios.post(`/private/viewActivity/${param?.id}`, {
        historyType: String(filterStatus), // 0---manage devices, 1---activityFed


      });

      setTableData(data?.data);
      setViewActivityData(data?.userData)



    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("error", error?.response);
      }
    } finally {
      setIsLoading(false);
    }
  };


  const LogoutUser = async (userId) => {
    try {


      const { data } = await axios({
        method: 'delete',
        url: `/private/logoutSubAdmin/${userId}`

      });

      toast.success(data?.message);
      getViewActivity(page);
    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        toast.error('Something went wrong', {
          position: "top-right",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };


  const backRoute =
    location.state?.from === "subAdminManagement"
      ? "/subAdminManagement"
      : location.state?.from === "reportedGigManagement"
        ? "/reportedGigManagement"
        : "/dashboard";


  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm style={{ gap: "1rem" }}>

            {/* heading */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer"
              }}
            >
              <div
                onClick={() => navigate(backRoute)}
              >
                <HiArrowNarrowLeft style={{ fontSize: "1.2rem" }} />
                <span className="common-heading ps-2" style={{ textTransform: 'capitalize' }}>Sub Admin History</span>
              </div>
            </div>

            <div className="Sub-Admin_Details">
              <div className="left_subAdmin">
                <div className="left_subAdmin_image">
                  <img
                    src={viewActivityData?.profileImage || placeholder}
                    style={{ height: "100%", width: "100%", borderRadius: "50%", position: "relative", zIndex: "0" }}
                    alt="Profile"
                  />
                  {viewActivityData?.isActive === true && (
                    <div
                      style={{
                        height: "1.2rem",
                        width: "1.2rem",
                        borderRadius: "50%",
                        background: "green",
                        marginLeft: "7rem",
                        zIndex: "1",
                        position: "relative",
                        top: "-26px"

                      }}
                    ></div>
                  )}
                </div>

                <div className="Main_content_subAdmin">
                  <div className="text_content_subAdmin"><span><FaUser style={{ color: " #025D70", }} /></span> {viewActivityData?.subAdminTitle}</div>
                  <div className="text_content_subAdmin"> <span><RiFolderUserFill style={{ color: " #025D70", }} /></span> Team ID : <span style={{ color: "#025D70" }}>{viewActivityData?.userId}</span></div>
                </div>
              </div>
              <div className="Right_subAdmin">
                <div className="Details_Right_subAdmin">Details</div>
                <div className="LastActivHeading">Last Active</div>
                <div className="LastActivDate"> {extractDate(viewActivityData?.lastActive)}</div>
              </div>
            </div>




            {/* Button Section */}
            <div className="nav_button_Gig">
              <div style={{ display: "flex", justifyContent: "space-between", width: "30rem", }}>
                <div className={`nav_button_text  ${filterStatus == "0" ? 'active' : ''
                  }`}
                  onClick={() => {
                    setFilterStatus("0");
                  }}
                >
                  Manage Devices</div>
                <div className={`nav_button_text ${filterStatus == "1" ? 'active' : ''
                  }`}
                  onClick={() => {
                    setFilterStatus("1");
                  }}
                >
                  Activity Feed</div>
              </div>
            </div>


            {/* overview Content Data     */}
            {filterStatus == "0" && (
              <TableContainer className={classes.tableMainContainer}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow className={classes.tableHeadingRow}>
                      <TableCell className={classes.tableHeadingCell}>S.No</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Device ID</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Device Name</TableCell>
                      <TableCell className={classes.tableHeadingCell}>First Sign In</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Last Active</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData?.length > 0 ? (
                      tableData.map((user, index) => (
                        <TableRow className={classes.tableBodyRow} key={user._id}>
                          <TableCell className={classes.textMiddle}>
                            {index + 1 + rowsPerPage * (page - 1)}
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>
                              {user?.deviceId ? user.deviceId.slice(-8) : "N/A"}
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>
                              {user?.deviceType || "N/A"}
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>
                              {extractOnlyDate(get(user, "createdAt", "---"))}
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>
                              {extractOnlyDate(get(user, "createdAt", "---"))}
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}
                            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                          >
                            <div style={{ background: "#FFEFEF", height: "2rem", width: "3rem", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
                              onClick={() => {
                                setDeleteModal(true);
                                setSelectedUserId(user._id); // Save the clicked user's ID
                              }}
                            >
                              <FiLogOut style={{ color: "#FF493A", fontSize: "1.2rem" }} />
                            </div>
                          </TableCell>

                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={9} align="center" style={{ padding: "2rem" }}>
                          <DashHeading style={{ textAlign: "center", color: "#000" }}>
                            No Data Found !!
                          </DashHeading>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}



            {/* hire Content Data     */}
            {filterStatus == "1" && (
              <TableContainer className={classes.tableMainContainer}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow className={classes.tableHeadingRow}>
                      <TableCell className={classes.tableHeadingCell}>S.No</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Status</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Date & Time</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Action Performed</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Output</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData?.length > 0 ? (
                      tableData.map((user, index) => (
                        <TableRow className={classes.tableBodyRow} key={user._id}>
                          <TableCell className={classes.textMiddle}>
                            {index + 1 + rowsPerPage * (page - 1)}
                          </TableCell>
                          <TableCell className={classes.textMiddle} style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "22px",
                                width: "60px",
                                fontSize: "12px",
                                fontFamily: "Roboto",
                                fontWeight: "400",
                                borderRadius: "4px",
                                color: get(user, "status", false) === true ? "#119926" : "#FF4141",
                                background: get(user, "status", false) === true ? "#E1F6DF" : "#FFD8D8"
                              }}
                            >
                              {get(user, "status", false) === true ? "Success" : "Fail"}
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>

                            <div>{extractDate(get(user, "createdAt", "---"))}</div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>
                              {get(user, "actionPerformed", "N/A")}
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            {get(user, "output", "N/A")}
                          </TableCell>

                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={9} align="center" style={{ padding: "2rem" }}>
                          <DashHeading style={{ textAlign: "center", color: "#000" }}>
                            No Data Found !!
                          </DashHeading>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}


          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer >


      < Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={deleteModal}
        onClose={() => {
          setDeleteModal(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div div >
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2 style={{ cursor: "pointer" }} onClick={() => setDeleteModal(false)} />
            </div>
            <p className="profile-section-text-data">Logout Sub Admin</p>
            <div className="block-header">Are you sure you want to Logout this Sub Admin? Please confirm.</div>
          </div >
        }
        content={
          <>
            <div className="logout-button-group">
              <div
                className="cancel-button"
                onClick={() => {
                  setDeleteModal(false);

                }}
              >
                Cancel
              </div>
              <div
                className="logout-button"
                style={{ background: "#EA5455", cursor: "pointer" }}
                onClick={() => {
                  setDeleteModal(false);
                  // navigate("/subAdminManagement")
                  LogoutUser(selectedUserId)
                }}
              >
                Yes
              </div>

            </div>
          </>
        }
      />


      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubAdminHistory);



